<template>
    <svg class="icon" :width="width" :height="height">
      <use :xlink:href="`${test}#${name}`" />
    </svg>
</template>
  
  <script>
  import test from './Icon.svg';
  
  export default {
    name: 'Icon',
    props: {
      name: { type: String, required: true },
      width: { type: Number, default: 24 },
      height: { type: Number, default: 24 },
    },
    data() {
      return { test };
    },
  };
  </script>